import React, {useEffect, useState} from 'react'
import ModalLayout from "../../../layouts/modal";
import ZaamAgeConfirmationNote from "./ZaamAgeConfirmationNote"
import { zaamPrices } from '../../../services/instalments.service';
import VatWrapper from '../../Common/VatWrapper';
import Translations from "../../../services/translation";
import "./style.scss";
import StringToHtml from '../../../components/StringToHtml/StringToHtml';

const ZaamPaymentSchedule = ({close, installmentsArr, savedPlan}) => {
    const strings = Translations["keys"][Translations.activeLang];
    const [vat, setVat] = useState(true);
    const [detailedPrices, setDetailedPrices] = useState(null);
    useEffect(()=>{
        if(installmentsArr.length > 0 && savedPlan){
            let prices = zaamPrices(savedPlan, installmentsArr);
            setDetailedPrices(prices);
        }
    },[installmentsArr, savedPlan]);

    return <ModalLayout
        close={close}
        size="tall wide"
        title={strings['ZAAM_SCHEDULE_TITLE']}
        extras='zaam-schedule-modal'>
            <div className='zaam-instalments-powered-by medium'>
                <p>{strings['ZAAM_POWEREDBY']}</p>
            </div>
            <div className="zaam-schedule-wrapper">
            <div className="zaam-schedule-content">
                <p className="body-title vmo-bold">{strings["ZAAM_PAYMENT_SCHEDULE_BODY_TITLE"]}</p>
                <div className="payment-schedule ">
                    <p className="price-section today">
                        <span className="text vmo-bold">Today</span>
                        <span className="amount vmo-bold">AED {detailedPrices?.todayPayment?.[+!vat]}</span>
                    </p>
                    <p className="price-section">
                        <span className="text">plan</span>
                        <span className="amount">AED {detailedPrices?.planPriceArr?.[+!vat]}</span>
                    </p>
                    <p className="price-section">
                        <span className="text">Device subscription</span>
                        <span className="amount">AED {detailedPrices?.subscription?.[+!vat]}</span>
                    </p>
                    <p className="price-section subscription-months" style={{marginTop:'23px'}}>
                        <span className="text vmo-bold">Month 2 - 12</span>
                        <span className="amount vmo-bold">AED {detailedPrices?.subscription?.[+!vat]}</span>
                    </p>
                    <p className="price-section">
                        <span className="text">Device subscription (Monthly)</span>
                    </p>
                </div>
                <p className="minimum-duration-note vmo-bold">
                    <StringToHtml stringValue={strings["ZAAM_PAYMENT_SCHEDULE_MINIMUM_DURATION"]}/>
                    <a href='https://portal.zaam.life/terms-of-use' target='_blank' rel="noopener noreferrer">
                        <p style={{fontSize:'14px'}} className="zaam-minimum-note-TC default-link vmo-bold">{strings["ZAAM_MINIMUM_SUBSCRIPTIONS_NOTE_TC"]}</p>
                    </a>
                    
                    </p>
            
                <div className="total">
                    <p className="price-section">
                        <span className="text vmo-bold">Total</span>
                        <span className="amoun vmo-bold">AED {detailedPrices?.todayPayment?.[+!vat]}</span>
                    </p>
                </div>
                <div className="vat-wrapper" style={{textAlign: "center", marginBottom: "30px"}}>
                <VatWrapper callback={(vat)=>setVat(vat)}/>
                </div>
                <ZaamAgeConfirmationNote />
                <div className="btn-container">
                <button className="vmo-button vmo-button-round vmo-button-wide vmo-button-red"
                onClick={close}>
                    {strings["GENERIC_CLOSE"]}
                </button>
                </div>
            </div>
            </div>
    </ModalLayout>
}

export default ZaamPaymentSchedule;